import React, {useState,useEffect} from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Chip
} from "@mui/material";
import { UserApiService } from "../../services/api";


const formatDate = (iso) => {
  const date = new Date(iso);
  return date.toUTCString(); // returns e.g., "Fri, 16 May 2025 16:00:00 GMT"
};

export default function MessageView({phone}) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = () => {
    setLoading(true);
    UserApiService.userScheduleMessage(phone)
      .then((response) => {
        setMessages(response);
      })
      .catch((errResponse) => {
        console.log("errResponse", errResponse);
      })
      .finally(() => setLoading(false));
  };

  const getStatusChipColor = (status) => {
    switch (status) {
      case 'trigger':
        return 'success'; // green
      case 'new':
        return 'info'; // blue
      case 'failed':
        return 'error'; // red (optional)
      default:
        return 'default';
    }
  };

  return (
    <>
    {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="50vh"
        >
          <CircularProgress />
        </Box>
      ) : (

    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Message</strong>
            </TableCell>
            <TableCell>
              <strong>Status</strong>
            </TableCell>
            <TableCell>
              <strong>Schedule Time</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {messages.map((msg, index) => (
            <TableRow key={index}>
              <TableCell>{msg.body}</TableCell>
              <TableCell><Chip
                  label={msg.status === "trigger" ? "Sent" : "Yet to send"}
                  color={getStatusChipColor(msg.status)}
                  variant="outlined"
                /></TableCell>
              <TableCell>{formatDate(msg.schedule_time)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      )}
      </>
  );
}
